import {
    getCusMsgTemplateConfig,
    getUserTicketInfoList,
    getTemplateFieldsInfo,
    getUserDealTicketInfoList,
    getTicketTypeInfoList,
    postMsg,
    isMessage,
    postMsgAfterVerify,
    addTicketSatisfactionScoreInfo,
    invokeOtherByUser,
    revokeWorkOrder,
    sendShortEmailMessage,
    verifyShortEmailMessage
} from '../services/leaveMsg';

export default {
    namespace: 'leaveMsg',
    state: {
        isEvalution: 0,
        txtFlag: 0,
        score: 0,
        remark: '',
        isUpload: false,
        isMsgFlag: 0, //是否留言
        isMsgStr: {},
        ticketId: '',
        leaveMsgInfo: {},
        currentItem: 1, //tab展示类型 1请您留言,2留言记录,3留言详情,4单独一个留言记录
        originField: [],
        templateFieldsInfo: [],
        extendFields: {},
        ticketTypeList: [],
        leaveMsgList: [],
        messageDetail: [],
        zoomImgDisplay: 0, //是否预览图片
        zoomImgSrc: '', //预览的图片地址
        isDefaultButton: '', // 评价提交按钮
        buttonDesc: '', // 提交按钮文字
        guideCopyWriting: '', // 评价引导语
        txtDesc: '', // 输入框引导语
    },
    reducers: {
        update(state, { payload }) {
            // console.log(payload);
            return {
                ...state,
                ...payload,
            };
        },
        changeItem(state, { payload }) {
            return {
                ...state,
                currentItem: payload,
            };
        },
        changeFieldsValue(state, { payload }) {
            return {
                ...state,
                extendFields: Object.assign(state.extendFields, payload),
            };
        },
        changeTicketList(state, { payload }) {
            return {
                ...state,
                ticketTypeList: payload,
            };
        },
    },
    effects: {
        *getCusMsgTemplate({ payload, callback }, { call, put }) {
            const config = yield call(getCusMsgTemplateConfig, {
                param: JSON.stringify({
                    templateId: payload.templateid,
                }),
                uid: payload.uid,
            });
            if (config.retCode === '000000') {
                const {
                    templateId,
                    ticketTypeFlag,
                    msgTmp,
                    emailFlag,
                    emailShowFlag,
                    telFlag,
                    telShowFlag,
                    enclosureFlag,
                    enclosureShowFlag,
                } = config.item;
                //调用分类查询
                if (ticketTypeFlag === 1) {
                    const ticketTypeList = yield call(getTicketTypeInfoList, {
                        uid: payload.uid,
                    });
                    yield put({ type: 'update', payload: { ticketTypeList: ticketTypeList.data.items } });
                }
                const fields = yield call(getTemplateFieldsInfo, {
                    param: JSON.stringify({
                        operateType: 3,
                        openFlag: 1,
                        templateId: templateId,
                    }),
                    uid: payload.uid,
                });
                const items = fields.data.items;
                let extendFields = {};
                if (fields.status === 200 && fields.data.retCode === '000000') {
                    const originField = [
                        {
                            cusFieldConfig: {
                                fieldId: 'ticketContent',
                                fieldType: 3,
                                fillFlag: 1,
                                showField: 1,
                                fieldName: '问题描述',
                                operateType: 'origin',
                                placeholder: msgTmp.replace(/<[^>]+>|&#39;|&nbsp;|&amp;|&lt;|&gt;|&quot;/g, ''),
                            },
                        },
                        {
                            cusFieldConfig: {
                                fieldId: 'file',
                                fieldType: 4,
                                fieldName: '附件',
                                fillFlag: enclosureFlag,
                                showField: enclosureShowFlag,
                                operateType: 'origin',
                            },
                        },
                        {
                            cusFieldConfig: {
                                fieldId: 'customerEmail',
                                fieldType: 1,
                                fieldName: '邮箱',
                                fillFlag: emailFlag,
                                showField: emailShowFlag,
                                operateType: 'origin',
                            },
                        },
                        {
                            cusFieldConfig: {
                                fieldId: 'customerPhone',
                                fieldType: 3,
                                fieldName: '手机',
                                fillFlag: telFlag,
                                showField: telShowFlag,
                                operateType: 'origin',
                            },
                        },
                    ];
                    items.forEach(obj => {
                        const { fieldId } = obj.cusFieldConfig;
                        extendFields[fieldId] = '';
                    });
                    yield put({
                        type: 'update',
                        payload: {
                            leaveMsgInfo: config.item,
                            templateFieldsInfo: items,
                            originField,
                            extendFields,
                        },
                    });
                    callback();
                }
            }
        },
        *getMsgRecordList({ payload }, { call, put }) {
            // console.log(payload)
            // console.log(getUserTicketInfoList)
            const data = yield call(getUserTicketInfoList, {
                ...payload,
                partnerId: window.urlObject.partnerId || '',
                sysNum: window.urlObject.sysNum || '',
            });
            // console.log(data)
            if (data.retCode === '000000') {
                yield put({
                    type: 'update',
                    payload: {
                        leaveMsgList: data.items,
                    },
                });
            } else {
            }
        },
        *addLeaveMsg({ payload, callback }, { call, put }) {
            let data = {};
            if (payload.msgFlag) {
                data = yield call(postMsgAfterVerify, {
                    ...payload,
                });
            } else {
                data = yield call(postMsg, {
                    ...payload,
                    partnerId: window.urlObject.partnerId || '',
                    sysNum: window.urlObject.sysNum || '',
                });
            }
            if (data.retCode === '000000') {
                callback();
            } else {
            }
        },
        *getLeaveMsgDetail({ payload }, { call, put }) {
            const data = yield call(getUserDealTicketInfoList, {
                uid: payload.uid,
                param: JSON.stringify(payload.param),
            });
            if (data.retCode === '000000') {
                const arr = data.items;
                let msgDetail = [];
                arr.forEach(obj => {
                    if (obj.replayList) {
                        obj.replayList.forEach(o => {
                            msgDetail.push({
                                content: o.replyContent,
                                flag: obj.flag,
                                isOpen: obj.flag,
                                time: o.replyTime,
                                timeStr: o.replyTimeStr,
                                startType: o.startType,
                                fileList: o.fileList,
                                revocation: o.revocation,
                            });
                        });
                    } else {
                        msgDetail.push(obj);
                    }
                });
                // console.log('data.items[0].txtFlag----',data.items[0].txtFlag);
                yield put({
                    type: 'update',
                    payload: {
                        currentItem: 3,
                        messageDetail: msgDetail,
                        isEvalution: data.items[0].isEvalution || 0,
                        score: data.items[0].score,
                        remark: data.items[0].remark,
                        ticketId: payload.param.ticketId,
                        txtFlag: data.items[0].txtFlag || 0,
                        isDefaultButton: data?.items[0]?.isDefaultButton === 0 ? 0 : 1,
                        buttonDesc: data?.items[0]?.buttonDesc || '',
                        guideCopyWriting: data?.items[0]?.guideCopyWriting || '',
                        txtDesc: data?.items[0]?.txtDesc || ''
                    },
                });
                yield put({
                    type: 'app/changeItem',
                    payload: payload.param.showType,
                });
            }
        },
        *getMessageInfo({ payload }, { call, put }) {
            const data = yield call(isMessage, {
                uid: payload.uid,
                msgFlag: 1, //h5
            });

            yield put({
                type: 'update',
                payload: {
                    isMsgFlag: data.isMessage,
                    isMsgStr: data.resStr && JSON.parse(data.resStr),
                },
            });
        },
        *commentService({ payload, callback }, { call, put, select }) {
            const { uid } = window.urlObject;
            const { leaveMsg } = yield select();
            const data = yield call(addTicketSatisfactionScoreInfo, {
                uid,
                param: JSON.stringify({
                    score: payload.score,
                    remark: payload.textValue,
                    ticketId: leaveMsg.ticketId,
                }),
            });
            const res = data;
            if (res.retCode === '000000') {
                yield put({
                    type: 'update',
                    payload: {
                        isEvalution: 1,
                        remark: res.item.remark,
                        score: res.item.score,
                    },
                });
            }
            callback(res);
        },

        *commitReplyService({ payload, callback }, { call, put, select }) {
            const { uid, sysNum } = window.urlObject;
            const { leaveMsg } = yield select();
            // invokeOtherByUser
            const data = yield call(invokeOtherByUser, {
                uid,
                method: 'post',
                param: JSON.stringify({
                    ticketId: leaveMsg.ticketId,
                    companyId: sysNum,
                    ...payload,
                }),
                url: 'ws/saveUserReplyInfo/4',
            });
            const res = data;
            const params = {
                uid,
                param: {
                    ticketId: leaveMsg.ticketId,
                    companyId: sysNum,
                    showType: 4,
                },
            };
            callback(res, params);
        },
        *revokeWorkOrder({ payload, callback }, { call, put, select }) {
            const { uid, sysNum } = window.urlObject;
            const { leaveMsg } = yield select();
            // revokeWorkOrder
            const data = yield call(revokeWorkOrder, {
                uid,
                method: 'post',
                param: JSON.stringify({
                    ticketId: leaveMsg.ticketId,
                    companyId: sysNum,
                    ...payload,
                }),
                url: 'ws/saveUserRevocationInfo/4',
            });
            const res = data;
            const params = {
                uid,
                param: {
                    ticketId: leaveMsg.ticketId,
                    companyId: sysNum,
                    showType: 4,
                },
            };
            callback(res, params);
        },
        *sendShortEmailMessage({ payload, callback }, { call, put }) {
            // console.log(payload)
            const data = yield call(sendShortEmailMessage, {
                ...payload,
                pid: window.urlObject.sysNum || '',
            });
            callback(data, payload);
        },
        *verifyShortEmailMessage({ payload, callback }, { call, put }) {
            // console.log(payload)
            const data = yield call(verifyShortEmailMessage, {
                ...payload,
            });
            callback(data, payload);
        },
    },
};
